import store from '@/js/store/store.js'

const customAction = {
  install: function (Vue) {
    Vue.directive('auth', {
      inserted: function (el, binding) {
        let hasAuth = false;
        let authCode = binding.expression.replace(/'/g, '');
        //let btnArr = store.getters.UserInfo.UserGrants || [];
        let grants = store.getters["user/UserInfo"].UserGrants || [];
        // console.log('权限');
        // console.log(grants);
        for (let i = 0; i < grants.length; i++) {
          if (grants[i].GrantCode.indexOf(authCode) > -1) {
            hasAuth = true;
            break;
          }
        }

        if (!hasAuth) {
          el.parentNode.removeChild(el);
        }
      }
    })
  }
}

export default customAction



// WEBPACK FOOTER //
// ./src/js/customAction.js